export default __webpack_public_path__ + "static/effective_functionality-540082bb977f4cac440273c02d258e9f.jpeg";